import React, { useState } from "react";
import SectionHeading from "../SectionHeading/SectionHeading";

const Contact = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    category: "General Inquiry",
    phone: "",
    subject: "",
    msg: "",
  });
  const [errors, setErrors] = useState({});

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const validateForm = () => {
    let newErrors = {};
    if (formData.name.trim().length < 3)
      newErrors.name = "Name must be at least 3 characters long.";
    if (!/^[0-9]{10}$/.test(formData.phone))
      newErrors.phone = "Enter a valid 10-digit phone number.";
    if (formData.subject.trim().length < 5)
      newErrors.subject = "Subject must be at least 5 characters long.";
    if (formData.msg.trim().length < 10)
      newErrors.msg = "Message must be at least 10 characters long.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    const formData = new FormData(event.target);
    formData.append("access_key", "7052490f-8fec-424b-b8f2-eb83840eb06e");

    const object = Object.fromEntries(formData);
    const json = JSON.stringify(object);

    const res = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: json,
    }).then((res) => res.json());

    if (res.success) {
      setFormData({
        name: "",
        category: "General Inquiry",
        phone: "",
        subject: "",
        msg: "",
      });
      setErrors({});
    }
    setLoading(false);
  };

  return (
    <section className="st-shape-wrap " id="contact">
      <SectionHeading
        title="Need Support?"
        subTitle=" Contact Us now for any queries or support."
      />
      <div className="container">
        <div className="row">
          <div className="col-lg-10 offset-lg-1">
            <form
              onSubmit={onSubmit}
              className="row st-contact-form st-type1"
              method="post"
              id="contact-form"
            >
              <div className="col-lg-6">
                <div className="st-form-field st-style1">
                  <label>Full Name</label>
                  <input
                    type="text"
                    name="name"
                    placeholder="Full Name"
                    onChange={handleInputChange}
                    value={formData.name}
                  />
                  {errors.name && <p className="error-text">{errors.name}</p>}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="st-form-field st-style1">
                  <label>Category</label>
                  <select
                    name="category"
                    onChange={handleInputChange}
                    value={formData.category}
                  >
                    <option value="General Inquiry">General Inquiry</option>
                    <option value="Report Bug">Report Bug</option>
                    <option value="Report Content">Report Content</option>
                    <option value="Account Deletion">
                      Request For Account Deletion
                    </option>
                    <option value="Account Deletion">Other...</option>
                  </select>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="st-form-field st-style1">
                  <label>Subject</label>
                  <input
                    type="text"
                    name="subject"
                    placeholder="Write subject"
                    onChange={handleInputChange}
                    value={formData.subject}
                  />
                  {errors.subject && (
                    <p className="error-text">{errors.subject}</p>
                  )}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="st-form-field st-style1">
                  <label>Phone</label>
                  <input
                    type="text"
                    name="phone"
                    placeholder="Phone"
                    onChange={handleInputChange}
                    value={formData.phone}
                  />
                  {errors.phone && <p className="error-text">{errors.phone}</p>}
                </div>
              </div>
              <div className="col-lg-12">
                <div className="st-form-field st-style1">
                  <label>Your Message</label>
                  <textarea
                    name="msg"
                    placeholder="Write your message here..."
                    onChange={handleInputChange}
                    value={formData.msg}
                  />
                  {errors.msg && <p className="error-text">{errors.msg}</p>}
                </div>
              </div>
              <div className="col-lg-12 text-center">
                <button
                  className="st-btn st-style1 st-color1 st-size-medium"
                  type="submit"
                  id="submit"
                >
                  {loading ? "Sending..." : "Send Message"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
